<template>
  <div class="login-container">
    <div class="login_header">
      <img class="logo" src="/images/welcome.png" />
      <span class="app-name">{{ APP_TITLE }}</span>
    </div>
    <div
      class="login_bg"
      style="background-image: url('https://fscdn.zto.com/fs8/M01/10/8D/wKhBEF8ZAQKAXj9WAAGgN37-DRA413.png')"
    >
      <div class="login_modal">
        <div class="login-form">
          <div class="login-content">
            <div class="tabs-nav">
              <div
                class="nav-item"
                :class="{ active: loginModel.mode === LoginMode.PASSWORD }"
                @click="changeLoginMode(LoginMode.PASSWORD)"
              >
                <span>密码登录</span>
              </div>
            </div>
            <div v-if="loginModel.mode === LoginMode.PASSWORD" class="login-section">
              <div class="login-group">
                <el-input
                  :maxlength="11"
                  class="input"
                  clearable
                  v-model="loginModel.mobile"
                  size="large"
                  placeholder="请输入手机号"
                />
                <el-input
                  class="input"
                  v-model="loginModel.password"
                  show-password
                  clearable
                  size="large"
                  :maxlength="25"
                  placeholder="请输入密码"
                />
              </div>
            </div>
            <div class="login-footer">
              <el-button class="login-btn" type="primary" size="large" @click="handleLogin">登录</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">营销柜系统©2025-2026</div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, reloadUrl, useCurrentAppInstance, onMounted } from '@zto/zpage'

enum LoginMode {
  PASSWORD = 1 // 密码登录
}

interface LoginModel {
  mode: LoginMode
  tenantId: string
  password?: string
  mobile: string
}

const app = useCurrentAppInstance()
const { Message } = app.useMessage()
const loginModel = ref<LoginModel>({
  mode: LoginMode.PASSWORD,
  tenantId: 'TENANT0001',
  password: '',
  mobile: ''
})
function changeLoginMode(mode: LoginMode) {
  loginModel.value.mode = mode
}

function isPhone(phone: string) {
  const mobilereg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
  return mobilereg.test(phone)
}

function handleLogin() {
  if (!isPhone(loginModel.value.mobile)) {
    Message.error('请输入正确的手机号')
    return
  }
  if (loginModel.value.mode === LoginMode.PASSWORD) {
    if (!loginModel.value.password) {
      Message.error('请输入正确的密码')
      return
    }
  }

  doLogin()
}

/** 执行登录 */
async function doLogin() {
  await app.apis.authApi.login(loginModel.value)

  reloadUrl(window.location.origin)
}

const APP_TITLE = ref()
</script>

<style lang="scss" scoped>
.login-container {
  .img-ios,
  .img-android {
    position: absolute;
    bottom: 10px;
    width: 100px;
    height: 100px;
  }
  .img-ios {
    left: 400px;
  }
  .img-android {
    left: 550px;
  }
  .login_header {
    height: 90px;
    background-color: #fff;
    display: -webkit-flex;
    display: flex;
    -webkit-align-items: center;
    padding-left: 40px;

    .logo {
      width: 200px;
      height: 57px;
    }

    .app-name {
      font-size: 22px;
      font-weight: 800;
      vertical-align: middle;
      color: #1890ff;
      margin-left: 10px;
    }
  }

  .login_bg {
    position: relative;
    width: 100%;
    background-size: cover;
    background-position: 50%;
    padding-top: 8%;
    padding-bottom: 8%;
    -webkit-flex: 1 1 auto;
    flex: 1 1 auto;
    display: -webkit-flex;
    display: flex;
    -webkit-justify-content: flex-end;
    justify-content: flex-end;
    -webkit-align-items: center;
    align-items: center;
  }

  .login_modal {
    position: relative;
    width: 400px;
    box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.1);
    border-radius: 16px;
    background: #fff;
    margin-right: 12%;

    .login-content {
      padding: 36px 40px 25px;
      box-sizing: border-box;

      .tabs-nav {
        padding: 16px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        display: flex;
        justify-content: center;

        .nav-item {
          cursor: pointer;

          &.active {
            font-weight: bold;
          }

          span {
            margin: 0 32px 0 0;
            font-size: 24px;
            color: #1890ff;
          }
        }
      }

      .login-group {
        margin-top: 40px;

        .input {
          width: 100%;
          margin-bottom: 20px;
        }

        .el-input__inner {
          //height: 48px;
        }
      }

      .login-footer {
        width: 100%;
        margin-top: 20px;
        margin-bottom: 24px;

        .el-button {
          width: 100%;
          font-size: 16px;
          font-weight: 400;
        }
      }
    }
  }

  .footer {
    line-height: 80px;
    color: #606266;
    font-size: 14px;
    width: 100%;
    bottom: 0;
    text-align: center;
  }
}
</style>
